<template lang="pug">
  b-container(fluid="lg")
    .tabla.sombra
      list-internal-users(:user-list="userList" :store-id="storeId")
</template>

<script>
import ListInternalUsers from '../components/user/ListInternalUsers.vue'

export default {
  components: {
    ListInternalUsers
  }
}
</script>
